import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select } from 'antd';

const { Option } = Select;

const DatabaseDetailModal = ({ visible, onCancel, onAdd, itemId }) => {
  const [form] = Form.useForm();
  const [databaseDetail, setDatabaseDetail] = useState({});

  useEffect(() => {
    if (itemId) {
      fetchDatabaseDetail(itemId);
    }
  }, [itemId]);

  useEffect(() => {
    if (databaseDetail) {
      form.setFieldsValue(databaseDetail);
    }
  }, [databaseDetail, form]);

  const fetchDatabaseDetail = async (id) => {
    try {
      const response = await fetch(`//dai.caihuiltd.com/api/get-baseList/${id}`, {
        method: 'GET',
        mode: 'cors',
      })
      // 检查响应状态
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      // 解析JSON数据
      const result = await response.json();
      // 将数据存储到状态中
      // console.log(result);
      const mappedData = {
        type: result.data[0].type,
        host: result.data[0].host,
        port: result.data[0].port,
        username: result.data[0].username,
        password: result.data[0].password,
        database_name: result.data[0].database_name
        ,
      };
      setDatabaseDetail(mappedData);
    } catch (error) {
      console.error('Error fetching database detail:', error);
    }
  };

  const handleOk = () => {
    form.validateFields()
      .then(values => {
        console.log('Received values from form: ', values);
        // 发送请求到后端
        fetch(`//dai.caihuiltd.com/api/post-baseList/${itemId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          mode: 'cors',
          body: JSON.stringify(values),
        })
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(data => {
            console.log('Success:', data);
            onAdd()
          })

          .catch(error => {
            console.error('Error updating database:', error);
          });
      })
      .catch(info => {
        console.log('Validate Failed:', info);
      });
  };

  return (
    <Modal
      title="Database Details"
      open={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText="Save changes"
      cancelText="Cancel"
    >
      <Form form={form} layout="vertical" initialValues={databaseDetail}>
        <Form.Item label="Database Type" name="type">
          <Select>
            <Option value="mysql">MySQL</Option>
            <Option value="oracle">Oracle</Option>
          </Select>
        </Form.Item>
        <Form.Item label="Data Source" name="host">
          <Input />
        </Form.Item>
        <Form.Item label="Port Number" name="port">
          <Input />
        </Form.Item>
        <Form.Item label="Username" name="username">
          <Input />
        </Form.Item>
        <Form.Item label="Password" name="password">
          <Input type="password" />
        </Form.Item>
        <Form.Item label="database_name" name="database_name">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DatabaseDetailModal;
